// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gc-user-img {
  width: 46px;
  height: 46px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gc-user-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-user-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.opacity-6 {
  cursor: default;
  opacity: 0.6;
}

.relative {
  position: relative;
}

:host ::ng-deep .p-menu.p-menu-overlay {
  position: absolute !important;
  top: 13px !important;
  left: -193px !important;
}

.gc-user-agencies {
  width: 31px;
  height: 31px;
  overflow: hidden;
  color: #2d388b;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  flex: 0 0 31px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-user-agencies .last-agency-icon {
  border-radius: 50%;
  background-color: #E7ECF0;
  color: #2d388b;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  width: 31px;
  height: 31px;
}

.add-associated-agency {
  width: 100px;
  height: 30px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  /* identical to box height, or 188% */
  color: #1F2937;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.add-associated-agency-plus {
  cursor: pointer;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border: 1px solid #2B3990;
  border-radius: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.country-code, .country-code-dropdown {
  width: 32px;
  height: 30px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #4B5563;
  mix-blend-mode: normal;
}

.country-code-dropdown {
  width: 50px;
}

.password-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1F2937;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #C7C7C7;
  padding: 4px;
}

.remove-chips {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #F65353;
  cursor: pointer;
}

.password-error-text {
  font-size: 12px;
  padding-left: 10px;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.gc-add-agency {
  padding-bottom: 20px;
  margin-bottom: 13px;
  border-width: 0 0 1px 0;
  border-style: dashed;
  border-color: #D1D5DB;
}
.gc-add-agency:first-child, .gc-add-agency:last-child {
  border: none !important;
}

.disable-click {
  pointer-events: none;
}

.cursor-pointer {
  cursor: pointer;
}

.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 360px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header p-button {
  margin: 0;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.m-l-12 {
  margin-left: 12px;
}

:host ::ng-deep .p-checkbox-label {
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/users/ioh-users/users.component.scss"],"names":[],"mappings":"AA+CA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9CJ;;AAgDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7CF;;AA+CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AA5CF;;AA+CA;EACE,oBAAA;EACA,eAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,eAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,kBAAA;AA5CF;;AAgDE;EACE,6BAAA;EACA,oBAAA;EACA,uBAAA;AA7CJ;;AAgDA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7CJ;AA8CI;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA5CN;;AA+CA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AA5CF;;AA8CA;EACE,eAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3CF;;AAwDA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AArDF;;AAwDA;EAEE,WAAA;AAtDF;;AAyDA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtDF;;AAwDA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AArDF;AAsDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qFAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AApDJ;;AAuDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AApDF;;AAsDA;EACE,eAAA;EACA,kBAAA;AAnDF;;AAqDA;EACE,8BAAA;AAlDF;;AAoDA;EACE,6BAAA;AAjDF;;AAmDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;AAhDF;AAiDI;EACE,uBAAA;AA/CN;;AAmDA;EACE,oBAAA;AAhDF;;AAmDA;EACE,eAAA;AAhDF;;AAoDE;EACE,cAAA;AAjDJ;AAoDE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAlDJ;AAqDE;EACE,SAAA;AAnDJ;AAsDE;EAfF;IAgBI,eAAA;IACA,2BAAA;EAnDF;EAoDE;IACE,eAAA;IACA,WAAA;EAlDJ;AACF;;AAsDA;EACE,iBAAA;AAnDF;;AAsDA;EAEE,mBAAA;AApDF","sourcesContent":["// .user-section {\n//     display: flex;\n//     flex-direction: column;\n//     align-items: left;\n//     margin: 20px;\n//   }\n\n//   .user-table {\n//     border-collapse: collapse;\n//     width: 100%;\n//     max-width: 800px;\n//     box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n//   }\n\n//   .user-table th,\n//   .user-table td {\n//     padding: 12px;\n//     text-align: left;\n//     border-bottom: 1px solid #ddd;\n//   }\n\n//   .user-table th {\n//     background-color: #f9f9f9;\n//     font-weight: bold;\n//   }\n\n//   .user-table tbody tr:nth-child(even) {\n//     background-color: #f2f2f2;\n//   }\n\n//   .user-table tbody tr:hover {\n//     background-color: #ddd;\n//   }\n\n//   .create-users {\n//     display: flex;\n//     justify-content: space-between;\n//     align-items: center;\n//   }\n\n// :host ::ng-deep .p-sidebar-right {\n//   width: 40% !important;\n// }\n\n// .m-35 {\n//   margin: 35px 0;\n// }\n.gc-user-img{\n    width: 46px;\n    height: 46px;\n    font-size: 18px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff;\n    color: #2d388b;\n    text-align: center;\n    font-size: 25px;\n    font-weight: 600;\n    flex: 0 0 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.gc-user-name{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #1F2937;\n}\np.gc-user-handle{\n  font-style: italic;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgb(75 85 99 / 50%);\n}\n\n.disabled {\n  pointer-events: none;\n  cursor: default;\n  opacity: 0.6;\n}\n\n.opacity-6 {\n  cursor: default;\n  opacity: 0.6;\n}\n\n.relative {\n  position: relative;\n}\n\n:host ::ng-deep {\n  .p-menu.p-menu-overlay {\n    position: absolute !important;\n    top: 13px !important;\n    left: -193px !important;\n  }\n}\n.gc-user-agencies{\n    width: 31px;\n    height: 31px;\n    overflow: hidden;\n    color: #2d388b;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 600;\n    flex: 0 0 31px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .last-agency-icon{\n      border-radius: 50%;\n      background-color: #E7ECF0;\n      color: #2d388b;\n      text-align: center;\n      font-size: 12px;\n      font-weight: 600;\n      width: 31px;\n      height: 31px;\n    }\n}\n.add-associated-agency{\n  width: 100px;\n  height: 30px;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 30px;\n  /* identical to box height, or 188% */\n  color: #1F2937;\n  /* Inside auto layout */\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n.add-associated-agency-plus {\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #2B3990;\n  border-radius: 46px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n// .add-associated-agency-plus-img {\n//   position: absolute;\n//   left: 90.38%;\n//   right: 16.25%;\n//   top: 94.7%;\n//   bottom: 50%;\n//   /*border: 2px solid #2B3990;*/\n// }\n\n\n\n.country-code {\n  width: 32px;\n  height: 30px;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 30px;\n  color: #4B5563;\n  mix-blend-mode: normal;\n}\n\n.country-code-dropdown {\n  @extend .country-code;\n  width: 50px;\n}\n\n.password-text {\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 30px;\n  color: #1F2937;\n}\n.assing-agncy {\n  height: 54px;\n  border: 1px solid #D1D5DB;\n  border-radius: 6px;\n  padding: 12px 16px;\n  display: flex;\n  .assing-agncy-img{\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff url(../../../assets/images/agency-icon-blue.svg) no-repeat  center center;\n    background-size: 45%;\n    color: #2d388b;\n    text-align: center;\n    font-size: 25px;\n    font-weight: 600;\n    flex: 0 0 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #C7C7C7;\n    padding: 4px;\n  }\n}\n.remove-chips{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n  text-align: right;\n  color: #F65353;\n  cursor: pointer;\n}\n.password-error-text {\n  font-size: 12px;\n  padding-left: 10px;\n}\n.gc-pr-12{\n  padding-right: 12px !important;\n}\n.gc-pl-12{\n  padding-left: 12px !important;\n}\n.gc-add-agency{\n  padding-bottom: 20px;\n  margin-bottom: 13px;\n  border-width: 0 0 1px 0;\n  border-style: dashed;\n  border-color: #D1D5DB;\n    &:first-child,&:last-child{\n      border: none !important;\n  }\n}\n\n.disable-click {\n  pointer-events: none;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.table-header{\n  h2 {\n    line-height: 1;\n  }\n\n  .table-search-wrapper {\n    max-width: 360px;\n    flex: 1 1 auto;\n    margin: 0;\n  }\n\n  p-button {\n    margin: 0;\n  }\n\n  @media(max-width:1200px) {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .table-search-wrapper{\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.m-l-12 {\n  margin-left: 12px;\n}\n\n:host ::ng-deep .p-checkbox-label\n {\n  margin-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
